export type Unit = '%' | 'm' | 'W/m' | '°'

export function kFormatter(num: number, suffix: Unit | undefined = undefined, toFixed = 0) {
  const isNegative = num < 0
  const absNum = Math.abs(num)
  const sign = isNegative ? '-' : ''

  if (suffix === '%') {
    return [num.toFixed(toFixed), '%']
  }
  if (suffix === 'm') {
    if (absNum > 999) return [`${sign}${(absNum / 1000).toFixed(toFixed)}`, 'km']
    return [`${sign}${absNum.toFixed(toFixed)}`, 'm']
  }
  const s = suffix ?? ''
  const scaled = (divisor: number) => Number((absNum / divisor).toFixed(toFixed))
  // Promote when rounding would print 1000 of the smaller unit (e.g. $999.8k → $1M, not $1000k).
  if (scaled(1_000_000) >= 1_000) {
    return [`${sign}${(absNum / 1_000_000_000).toFixed(toFixed)}`, `G${s}`]
  }
  if (scaled(1_000) >= 1_000) {
    return [`${sign}${(absNum / 1_000_000).toFixed(toFixed)}`, `M${s}`]
  }
  if (absNum >= 1_000) {
    return [`${sign}${(absNum / 1_000).toFixed(toFixed)}`, `k${s}`]
  }
  return [`${sign}${absNum.toFixed(toFixed)}`, s]
}

export function formatNumberAsPercent(num: number) {
  if (isNaN(num)) return String(num)
  const roundingIncrement = Math.abs(num) > 10 ? 100 : 1
  const formatter = new Intl.NumberFormat('en', {
    style: 'percent',
    roundingIncrement,
  })
  return formatter.format(num)
}
